import { PageConfig } from "config/page.config";
import { FormHeaderInfo } from "../models/form-header-info.model";

export class FormConstants {

    public static FORM_A_NAME = 'Single Entity Drug and Salt Form';
    public static FORM_B_NAME = 'Single Entity';
    public static FORM_C_NAME = 'Modified Salt Form';
    public static FORM_D_NAME = 'Revision to an Adopted USAN';
    public static FORM_E_NAME = 'Contact Lens Material';
    public static FORM_F_NAME = 'Biologics';

    public static FORM_A_TYPE = 'single-entity-drug-salt';
    public static FORM_B_TYPE = 'single-entity';
    public static FORM_C_TYPE = 'modified-salt';
    public static FORM_D_TYPE = 'revision-to-adopted-usan';
    public static FORM_E_TYPE = 'contact-lens-material';
    public static FORM_F_TYPE = 'biologics';

    public static FORM_A_TYPE_NAME = 'Single Entity Drug and Salt';
    public static FORM_B_TYPE_NAME = 'Single Entity';
    public static FORM_C_TYPE_NAME = 'Modified Salt';
    public static FORM_D_TYPE_NAME = 'Revision to an Adopted USAN';
    public static FORM_E_TYPE_NAME = 'Contact Lens Material';
    public static FORM_F_TYPE_NAME = 'Biologics';

    public static SERVICE_NOW_FORM_A_TYPE = 'Form A';
    public static SERVICE_NOW_FORM_B_TYPE = 'Form B';
    public static SERVICE_NOW_FORM_C_TYPE = 'Form C';
    public static SERVICE_NOW_FORM_D_TYPE = 'Form D';
    public static SERVICE_NOW_FORM_E_TYPE = 'Form E';
    public static SERVICE_NOW_FORM_F_TYPE = 'Form F';

    public static FORM_TYPE_TRANSLATION_MAP: Map<string, string> = new Map([
      [this.FORM_A_TYPE, this.SERVICE_NOW_FORM_A_TYPE],
      [this.FORM_B_TYPE, this.SERVICE_NOW_FORM_B_TYPE],
      [this.FORM_C_TYPE, this.SERVICE_NOW_FORM_C_TYPE],
      [this.FORM_D_TYPE, this.SERVICE_NOW_FORM_D_TYPE],
      [this.FORM_E_TYPE, this.SERVICE_NOW_FORM_E_TYPE],
      [this.FORM_F_TYPE, this.SERVICE_NOW_FORM_F_TYPE],
      ['FormA', this.SERVICE_NOW_FORM_A_TYPE],
      ['FormB', this.SERVICE_NOW_FORM_B_TYPE],
      ['FormC', this.SERVICE_NOW_FORM_C_TYPE],
      ['FormD', this.SERVICE_NOW_FORM_D_TYPE],
      ['FormE', this.SERVICE_NOW_FORM_E_TYPE],
      ['FormF', this.SERVICE_NOW_FORM_F_TYPE],
      [this.SERVICE_NOW_FORM_A_TYPE, this.SERVICE_NOW_FORM_A_TYPE],
      [this.SERVICE_NOW_FORM_B_TYPE, this.SERVICE_NOW_FORM_B_TYPE],
      [this.SERVICE_NOW_FORM_C_TYPE, this.SERVICE_NOW_FORM_C_TYPE],
      [this.SERVICE_NOW_FORM_D_TYPE, this.SERVICE_NOW_FORM_D_TYPE],
      [this.SERVICE_NOW_FORM_E_TYPE, this.SERVICE_NOW_FORM_E_TYPE],
      [this.SERVICE_NOW_FORM_F_TYPE, this.SERVICE_NOW_FORM_F_TYPE]
    ]);

  public static FORM_TYPE_MAP: Map<string, string> = new Map([
    [this.FORM_A_TYPE, this.SERVICE_NOW_FORM_A_TYPE],
    [this.FORM_B_TYPE, this.SERVICE_NOW_FORM_B_TYPE],
    [this.FORM_C_TYPE, this.SERVICE_NOW_FORM_C_TYPE],
    [this.FORM_D_TYPE, this.SERVICE_NOW_FORM_D_TYPE],
    [this.FORM_E_TYPE, this.SERVICE_NOW_FORM_E_TYPE],
    [this.FORM_F_TYPE, this.SERVICE_NOW_FORM_F_TYPE]
  ]);

  public static SERVICE_NOW_FORM_TYPE_MAP: Map<string, string> = new Map([
    [this.SERVICE_NOW_FORM_A_TYPE, 'FormA'],
    [this.SERVICE_NOW_FORM_B_TYPE, 'FormB'],
    [this.SERVICE_NOW_FORM_C_TYPE, 'FormC'],
    [this.SERVICE_NOW_FORM_D_TYPE, 'FormD'],
    [this.SERVICE_NOW_FORM_E_TYPE, 'FormE'],
    [this.SERVICE_NOW_FORM_F_TYPE, 'FormF']
  ])
    
  public static FORM_INFO_MAP: Map<string, FormHeaderInfo> = new Map([
    [this.SERVICE_NOW_FORM_A_TYPE, new FormHeaderInfo(this.FORM_A_TYPE, this.FORM_A_NAME, this.FORM_A_TYPE_NAME, 'This form is used when requesting a USAN for the base substance and a USAN for the modified (salt) form of a new compound, (for which no USAN exists) to be marketed in the United States. Applicants will receive two separate USAN(s); one for the parent and one for the salt form.<br><br> Please note that in the past, because the USAN Program required naming only the form of the compound to be marketed in the United States, and the INN Program names only the parent (base) product, a USAN and INN were often different. To maintain consistency and avoid FDA approval delays if a related substance is later marketed, the USAN Program now requires filing Form A to obtain USAN(s) for the salt and base forms of the compound. The fee associated with this application is $28,000.')],
    [this.SERVICE_NOW_FORM_B_TYPE, new FormHeaderInfo(this.FORM_B_TYPE, this.FORM_B_NAME, this.FORM_B_TYPE_NAME, 'Single entity form is used to request a USAN for a single entity (active moiety, parent compound) for which no modified or salt form will be developed or marketed in the United States. The fee associated with this application is $18,000.')],
    [this.SERVICE_NOW_FORM_C_TYPE, new FormHeaderInfo(this.FORM_C_TYPE, this.FORM_C_NAME, this.FORM_C_TYPE_NAME, 'Modified compound form is used to request a USAN for the modified (salt) form of a compound for which a USAN already exists. If a manufacturer finds that they have not requested a USAN for a salt to be marketed, or if they decide to market a different salt than what was named by the USAN Council, they are requested to pursue a USAN for the new salt form using Form C. The fee associated with this application is $10,000.')],
    [this.SERVICE_NOW_FORM_D_TYPE, new FormHeaderInfo(this.FORM_D_TYPE, this.FORM_D_NAME, this.FORM_D_TYPE_NAME, 'Revise established USAN is used to request a revision to a published, adopted USAN. The fee associated with this application is $5,000.<br><br>*Effective Feb. 1, 2026, firms may request one round of revisions to an adoption statement without incurring additional fees. After Feb. 1, 2026, additional revisions must be made by filing a USAN Revised submission, for which there is a fee. The USAN Revised submission must also be filed for revisions requested more than 60 days after the date of adoption. To avoid this additional fee, please list all requested changes on the adoption review form and return this form by the date listed on the statement of adoption.')],
    [this.SERVICE_NOW_FORM_E_TYPE, new FormHeaderInfo(this.FORM_E_TYPE, this.FORM_E_NAME, this.FORM_E_TYPE_NAME, 'Contact lens material form is used to request a USAN for contact lens materials. The fee associated with USAN for new contact lens materials is $18,000. The USANM and USANR fees are $10,000. (Form E is also used to request both USANM and USANR for contact lenses.)')],
    [this.SERVICE_NOW_FORM_F_TYPE, new FormHeaderInfo(this.FORM_F_TYPE, this.FORM_F_NAME, this.FORM_F_TYPE_NAME, 'Biologics form is for proteins, peptides, monoclonal antibodies, nucleic acids, all pegylated substances, cell therapies, and gene therapies. Fee for a new monoclonal antibody is $18,000.<br><br>Additional application requirements have been established for biologics. Please review these requirements and include with your application materials.')]
  ]);

  public static EMPTY_FORM_INFO: FormHeaderInfo = new FormHeaderInfo('', '', '', '');

  public static FORM_SECTION_NAME_MAP = [
    { key: 'showBasicInfoPanel', value: 'Basic Information' },
    { key: 'showMolecularInfoPanel', value: 'Molecular Information' },
    { key: 'showSubstanceDetailsPanel', value: 'Substance Details' },
    { key: 'showManufactureUsageInfoPanel', value: 'Manufacturer and Usage Information' },
    { key: 'showClinicalTrialInfoPanel', value: 'Clinical Trial Information' },
    { key: 'showUploadDocumentsPanel', value: 'Upload Documents' },
    { key: 'showApplicantInfoPanel', value: 'Applicant Information' },
    { key: 'showPaymentInfoPanel', value: 'Payment Information' },
    { key: 'showTermsAndConditionsPanel', value: 'Terms and Conditions' }
  ];

  public static SERVICE_NOW_FORM_TO_PATH_MAPPING: Map<string, string> = new Map([
    [ this.SERVICE_NOW_FORM_A_TYPE, PageConfig.paths.usan.forms.singleEntityDrugSalt ],
    [ this.SERVICE_NOW_FORM_B_TYPE, PageConfig.paths.usan.forms.singleEntity ],
    [ this.SERVICE_NOW_FORM_C_TYPE, PageConfig.paths.usan.forms.modifiedSalt ],
    [ this.SERVICE_NOW_FORM_D_TYPE, PageConfig.paths.usan.forms.revisionToAdoptedUsan ],
    [ this.SERVICE_NOW_FORM_E_TYPE, PageConfig.paths.usan.forms.contactLensMaterial ],
    [ this.SERVICE_NOW_FORM_F_TYPE, PageConfig.paths.usan.forms.biologics ]
  ]);
  public static FORM_NAME_MAP: Map<string, string> = new Map([
    ['FormA', this.FORM_A_NAME],
    ['FormB', this.FORM_B_NAME],
    ['FormC', this.FORM_C_NAME],
    ['FormD', this.FORM_D_NAME],
    ['FormE', this.FORM_E_NAME],
    ['FormF', this.FORM_F_NAME]
  ])

  public static REQUIRED_FIELD_TO_SECTION_NAME_MAP: Map<string, string[]> = new Map([
    [`Applicant Information`, [`applicantInfo`]],
    [`Basic Information`, [`suggestedNamesFormA`, `designationForSaltForm`, `chemicalNamesDescription`, `chemicalNamesDescriptionForSingleEntity`, `chemicalNamesDescriptionForSaltForm`, `systematicNamesOrDescription`]],
    [`Clinical Trial Information`, [`innSubmission`, `phase1ClinicalTrialStartDate`, `indApplicationNumbers`]],
    [`Manufacturer and Usage Information`, [`manufacturers`, `principalTherapeuticUses`, `pharmacologicAction`, `substanceBindsToTarget`]],
    [`Molecular Information`, [`molecularWeightForSingleEntity`, `molecularWeightForSaltForm`, `molecularWeight`]],
    [`Substance Details`, [`trademarks`, `casRegistryNumberForSingleEntity`, `casRegistryNumberForSaltForm`, `uniiNumberforSingleEntity`, `codeDesignationsForSingleEntity`, `casRegistryNumber`, `uniiNumberForSaltForm`, `codeDesignations`, `waterContentMeanValueStdDeviation`, `waterContentNumberOfMeasurements`, `oxygenMeanValueStdDeviation`, `oxygenNumberOfMeasurements`, `methodUsedToDetermineOxygenPermeability`]],
    [`Payment Information`, []]
  ]);

  public static FORM_PRICE_MAP: Map<string, string> = new Map([
    ['FormA', '28000'],
    ['FormB', '18000'],
    ['FormC', '10000'],
    ['FormD', '5000'],
    ['FormF', '18000']
  ])
  public static FORM_E_PRICE_MAP: Map<string, string> = new Map([
    ['New', '18000'],
    ['Revised', '10000'],
    ['Modified', '10000'],
  ])
  public static priceMap: Map<string, string> = new Map([
  
  ]);
  public static getKeyByValue(map: Map<string, any>, searchValue: string): string {
    let key = '';
    if(!searchValue) {
      return key;
    }

    map.forEach((v, k) => {
      if(Array.isArray(v) && (v as Array<any>).includes(searchValue)) {
        key = k; 
      }
      
      if(v === searchValue) {
        key = k;
      }

    });

    return key;
  }

}